import React from 'react';

const Footer = () => {

    return (
        <div className='main_container'>
            <footer 
                className='pt-[32px] pb-[67px]'
                data-aos="fade-in"
                data-aos-delay="300"
                data-aos-duration="300"
                data-aos-easing="ease-in-out"
            >
                <p className='text-textColor-500 text-[15px] text-center'>
                    2023 - All Rights Reserved - Luminode.io
                </p>
            </footer>
        </div>
    )
}

export default Footer;